module.exports = __webpack_public_path__ + "img/sleeve_flounce_width.7ccdb52b.png";